<template>
  <div>
    <div class="md-layout">
      <div
        class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-20"
      >
        <md-field>
          <label for="client"> Filter by Client: </label
          ><md-select
            v-model="filterCriteria.clientId"
            name="client"
            id="client"
            @md-selected="onFilterChange"
          >
            <md-option value="0">All</md-option>
            <md-option
              v-for="client in permittedClients"
              :key="client.id"
              :value="client.id"
            >
              {{ client.name }}
            </md-option>
          </md-select>
        </md-field>
      </div>
    </div>
    <div class="md-layout">
      <div
        class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25"
      >
        <stats-card header-color="warning">
          <template slot="header">
            <div class="card-icon">
              <md-icon>{{ quoteIcon }}</md-icon>
            </div>
            <p class="category">
              Quotes approved by client - ready for work to start
            </p>
            <h3 class="title">
              <router-link
                class="linkcolour"
                :to="{
                  name: 'Live Quotes',
                  query: {
                    clientId: this.filterCriteria.clientId,
                    contractorRegionId: this.filterCriteria.contractorRegionId,
                    statusId: 3
                  }
                }"
                ><strong>{{ quoteMetric.count }}</strong></router-link
              >
            </h3>
          </template>

          <template slot="footer">
            <div class="stats">
              Last quote order placed:
              {{ quoteMetric.lastUpdatedDate }}
            </div>
          </template>
        </stats-card>
      </div>
    </div>
    <div class="md-layout">
      <div
        class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-33"
      >
        <chart-card
          header-animation="false"
          :chart-data="timedDefectStatusesChart.data"
          :chart-options="options"
          chart-type="Pie"
          header-icon
          chart-inside-content
          background-color="primary"
        >
          <template slot="chartInsideHeader">
            <div class="card-icon">
              <md-icon>donut_large</md-icon>
            </div>
            <h4 class="title">
              <strong>Timed Defect Status</strong> - Total:
              {{ this.timedDefectStatusesChart.total }}
            </h4>
          </template>
          <template slot="footer">
            <div class="md-layout">
              <div class="md-layout-item md-size-100">
                <h6 class="category">Legend</h6>
              </div>
              <div class="md-layout-item">
                <i class="fa fa-circle text-danger"></i>
                <chart-link
                  :typeId="1"
                  :statusId="1"
                  :clientId="filterCriteria.clientId"
                  :value="timedDefectStatusesChart.data.series[0]"
                />
                <i class="fa fa-circle text-quote"></i>
                <chart-link
                  :typeId="1"
                  :statusId="7"
                  :clientId="filterCriteria.clientId"
                  :value="timedDefectStatusesChart.data.series[3]"
                />
                <i class="fa fa-circle text-warning"></i>
                <chart-link
                  :typeId="1"
                  :statusId="2"
                  :clientId="filterCriteria.clientId"
                  :value="timedDefectStatusesChart.data.series[2]"
                />
                <i class="fa fa-circle text-gray"></i>
                <chart-link
                  :typeId="1"
                  :statusId="4"
                  :clientId="filterCriteria.clientId"
                  :value="timedDefectStatusesChart.data.series[4]"
                />
                <i class="fa fa-circle text-info"></i>
                <chart-link
                  :typeId="1"
                  :statusId="5"
                  :clientId="filterCriteria.clientId"
                  :value="timedDefectStatusesChart.data.series[5]"
                />
                <i class="fa fa-circle text-purple"></i
                ><chart-link
                  :typeId="1"
                  :statusId="6"
                  :clientId="filterCriteria.clientId"
                  :value="timedDefectStatusesChart.data.series[6]"
                />
              </div>
            </div>
          </template>
        </chart-card>
      </div>
      <div
        class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-33"
      >
        <chart-card
          header-animation="false"
          :chart-data="untimedDefectStatusesChart.data"
          :chart-options="options"
          chart-type="Pie"
          header-icon
          chart-inside-content
          background-color="primary"
        >
          <template slot="chartInsideHeader">
            <div class="card-icon">
              <md-icon>donut_large</md-icon>
            </div>
            <h4 class="title">
              <strong>Untimed Defect Status</strong> - Total:
              {{ this.untimedDefectStatusesChart.total }}
            </h4>
          </template>
          <template slot="footer">
            <div class="md-layout">
              <div class="md-layout-item md-size-100">
                <h6 class="category">Legend</h6>
              </div>
              <div class="md-layout-item">
                <i class="fa fa-circle text-danger"></i>
                <chart-link
                  :typeId="2"
                  :statusId="1"
                  :clientId="filterCriteria.clientId"
                  :value="untimedDefectStatusesChart.data.series[0]"
                />
                <i class="fa fa-circle text-quote"></i>
                <chart-link
                  :typeId="2"
                  :statusId="7"
                  :clientId="filterCriteria.clientId"
                  :value="untimedDefectStatusesChart.data.series[3]"
                />
                <i class="fa fa-circle text-warning"></i>
                <chart-link
                  :typeId="2"
                  :statusId="2"
                  :clientId="filterCriteria.clientId"
                  :value="untimedDefectStatusesChart.data.series[2]"
                />
                <i class="fa fa-circle text-gray"></i>
                <chart-link
                  :typeId="2"
                  :statusId="4"
                  :clientId="filterCriteria.clientId"
                  :value="untimedDefectStatusesChart.data.series[4]"
                />
                <i class="fa fa-circle text-info"></i>
                <chart-link
                  :typeId="2"
                  :statusId="5"
                  :clientId="filterCriteria.clientId"
                  :value="untimedDefectStatusesChart.data.series[5]"
                />
                <i class="fa fa-circle text-purple"></i
                ><chart-link
                  :typeId="2"
                  :statusId="6"
                  :clientId="filterCriteria.clientId"
                  :value="untimedDefectStatusesChart.data.series[6]"
                />
              </div>
            </div>
          </template>
        </chart-card>
      </div>
      <div
        class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-33"
      >
        <chart-card
          header-animation="false"
          :chart-data="safedStatusesChart.data"
          :chart-options="options"
          chart-type="Pie"
          header-icon
          chart-inside-content
          background-color="primary"
        >
          <template slot="chartInsideHeader">
            <div class="card-icon">
              <md-icon>donut_large</md-icon>
            </div>
            <h4 class="title">
              <strong>SAFed Status</strong> - Total:
              {{ this.safedStatusesChart.total }}
            </h4>
          </template>
          <template slot="footer">
            <div class="md-layout">
              <div class="md-layout-item md-size-100">
                <h6 class="category">Legend</h6>
              </div>
              <div class="md-layout-item">
                <i class="fa fa-circle text-danger"></i>
                <chart-link
                  :typeId="5"
                  :statusId="1"
                  :clientId="filterCriteria.clientId"
                  :value="safedStatusesChart.data.series[0]"
                />
                <i class="fa fa-circle text-quote"></i>
                <chart-link
                  :typeId="5"
                  :statusId="7"
                  :clientId="filterCriteria.clientId"
                  :value="safedStatusesChart.data.series[3]"
                />
                <i class="fa fa-circle text-warning"></i>
                <chart-link
                  :typeId="5"
                  :statusId="2"
                  :clientId="filterCriteria.clientId"
                  :value="safedStatusesChart.data.series[2]"
                />
                <i class="fa fa-circle text-gray"></i>
                <chart-link
                  :typeId="5"
                  :statusId="4"
                  :clientId="filterCriteria.clientId"
                  :value="safedStatusesChart.data.series[4]"
                />
                <i class="fa fa-circle text-info"></i>
                <chart-link
                  :typeId="5"
                  :statusId="5"
                  :clientId="filterCriteria.clientId"
                  :value="safedStatusesChart.data.series[5]"
                />
                <i class="fa fa-circle text-purple"></i
                ><chart-link
                  :typeId="5"
                  :statusId="6"
                  :clientId="filterCriteria.clientId"
                  :value="safedStatusesChart.data.series[6]"
                />
              </div>
            </div>
          </template>
        </chart-card>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { ChartCard, StatsCard } from "@/components";
import ChartLink from "./components/ChartLink";
export default {
  components: {
    ChartCard,
    ChartLink,
    StatsCard
  },
  async created() {
    await this.getChartdData();
  },
  computed: {
    ...mapGetters({
      plantWithoutStatInspChart: "report/plantWithoutStatInspChartData",
      timedDefectStatusesChart: "report/timedDefectStatusesChartData",
      untimedDefectStatusesChart: "report/untimedDefectStatusesChartData",
      safedStatusesChart: "report/safedStatusesChartData",
      statInspStatusesChart: "report/statInspStatusesChartData",
      quoteMetric: "report/quoteMetric",
      quoteIcon: "quote/icon"
    }),
    permittedClients() {
      return this.$auth.profile.clients;
    }
  },
  data() {
    return {
      options: {
        donut: true,
        donutWidth: 35,
        showLabel: false
      },
      filterCriteria: {
        clientId: "0"
      }
    };
  },
  methods: {
    async getChartdData() {
      await this.$store.dispatch("report/getDashboard", {
        clientId: this.filterCriteria.clientId
      });
    },
    async onFilterChange() {
      await this.getChartdData();
    }
  }
};
</script>

<style lang="scss" scoped>
.text-center {
  text-align: center;
}
.category {
  margin: 0;
}

.md-card-actions .md-layout-item {
  padding: 0;
}
.linkcolour strong {
  color: #3c4858 !important;
}
</style>
